module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Silver Aluminum + Red Closed.e4cbaf0f.png";